// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8989":"aebb6d70","14403":"6446271b","14588":"aebb6d70","36362":"aebb6d70","56141":"d677f641"}[chunkId] + ".chunk.css";
};